/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/spaManager/applications"/>
export const applications = {
    administration: "Administration",
    advancedSearch: "AdvancedSearch",
    archiveSearch: "ArchiveSearch",
    createDocument: "CreateDocument",
    dashboard: "Dashboard",
    inbox: "Inbox",
    home: "Home"
};
